import React from 'react'
import useStyles from './ReportsFiltersSection.styles'
import {Typography, Grid} from '@material-ui/core'

type Props = {
  title: string
  children: React.ReactNode
}

function ReportsFiltersSection(props: Props) {
  const classes = useStyles()

  return (
    <Grid item>
      <Typography variant="h4" className={classes.title}>
        {props.title}
      </Typography>

      <div>{props.children}</div>
    </Grid>
  )
}

export default ReportsFiltersSection
